import { create } from "zustand";

interface ModalStore {
	showAbsenceFor?: {
		consultantId: string;
		absenceId?: string;
		title?: string;
		selectedDate?: string;
	};
	showMessageFor?: { consultantId: string; title?: string };
	toggleAbsenceModal: (data?: {
		consultantId: string;
		absenceId?: string;
		title?: string;
		selectedDate?: string;
	}) => any;
	toggleMessageModal: (data?: { consultantId: string; title?: string }) => any;
}

export const useModalStore = create<ModalStore>((set) => ({
	showAbsenceFor: undefined,
	toggleAbsenceModal: (data) =>
		set((state) => ({
			...state,
			showAbsenceFor: data,
		})),

	showMessageFor: undefined,
	toggleMessageModal: (data) =>
		set((state) => ({
			...state,
			showMessageFor: data,
		})),
}));
